import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';
import { IFetchFilesPayload, IFileFetch } from 'interfaces/File';

export interface ILocalFilesState {
  state: QueryState;
  parentID: Nullable<string>;
  dataset: Nullable<IFileFetch[]>;
  datasetByFolder: Nullable<IFetchFilesPayload['datasetByFolder']>;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const LocalFilesEmptyState: ILocalFilesState = {
  state: QueryState.UNDEFINED,
  parentID: null,
  dataset: null,
  datasetByFolder: null,
  error: null,
  accessToken: undefined
};
